import { render, staticRenderFns } from "./iamTrain.vue?vue&type=template&id=59ebc8c4&scoped=true&"
import script from "./iamTrain.vue?vue&type=script&lang=js&"
export * from "./iamTrain.vue?vue&type=script&lang=js&"
import style0 from "./iamTrain.vue?vue&type=style&index=0&id=59ebc8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ebc8c4",
  null
  
)

export default component.exports